import { FC, ReactNode } from 'react';

// components
import { Button } from 'dibs-elements/exports/Button';
import { FormattedMessage } from 'dibs-react-intl';

type Props = {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
    label?: ReactNode;
};

export const PdpSharedAuctionBidButton: FC<Props> = props => {
    const { className, onClick, disabled, label } = props;

    return (
        <>
            <Button
                type="primary"
                fullWidth
                className={className}
                onClick={onClick}
                disabled={disabled}
            >
                {label ? (
                    <>{label}</>
                ) : (
                    <FormattedMessage
                        id="PdpSharedAuctionBidButton.placeBid"
                        defaultMessage="Place Bid"
                    />
                )}
            </Button>
        </>
    );
};
